import { useCallback, useMemo, useState } from 'react';

import { createWorkflow } from '../../utils/stateMachine';

import type { WorkflowDefinition } from '../../utils/stateMachine';

export const useWorkflow = <T extends string, S extends string>(
  workflowDefinition: WorkflowDefinition<T, S>,
  defaultState: S
) => {
  const workflow = useMemo(
    () => createWorkflow(workflowDefinition, defaultState),
    [workflowDefinition, defaultState]
  );
  const [state, setState] = useState(workflow.getState());

  const apply = useCallback(
    (transition: T) => {
      workflow.apply(transition);
      setState(workflow.getState());
    },
    [workflow]
  );

  return {
    state,
    apply,
  };
};
